/**
 * PageSkeleton - generic chrome-only loading placeholder for route-level
 * Suspense. Replaces the full-screen branded loader on lazy route loads so
 * the app feels instant: bottom-nav stays, header stays, and the body
 * shows grey-boxed content the same shape as the real page.
 *
 * Used by <Suspense fallback>, NOT for cold app launch (that still uses
 * ElefaLoadingScreen via NativeRootGate so the first paint is branded).
 */
export function PageSkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="w-full px-4 pt-6 pb-24 space-y-4 animate-pulse"
    >
      <div className="h-7 w-1/2 rounded-md bg-muted" />
      <div className="h-4 w-2/3 rounded-md bg-muted/70" />
      <div className="mt-6 grid grid-cols-1 gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="h-16 rounded-xl bg-muted/60"
            style={{ animationDelay: `${i * 60}ms` }}
          />
        ))}
      </div>
    </div>
  );
}

export default PageSkeleton;
